import { getSettings, setSettings } from 'src/actions/mainSettingsActions';

export const REQUEST_SETTINGS = 'request_settings';
export const RECEIVE_SETTINGS = 'receive_settings';
export const SETTINGS_ERROR = 'settings_error';

export const REQUEST_SET_SETTINGS = 'request_set_settings';
export const RECEIVE_SET_SETTINGS = 'receive_set_settings';
export const SET_SETTINGS_ERROR = 'set_settings_error';

const setSettingsRedux = (settingsCategory, newSettingsObject) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_SET_SETTINGS,
			payload: settingsCategory,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_SET_SETTINGS,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: SET_SETTINGS_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const newSettings = await setSettings(`${settingsCategory}Settings`, newSettingsObject);

		console.log('newSettings', newSettings);

		return onSuccess({ settingsCategory, settings: newSettings });
	} catch (error) {
		console.log(error);
		return onError({ error, settingsCategory });
	}
};

const getSettingsRedux = (settingsCategory) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_SETTINGS,
			payload: settingsCategory,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_SETTINGS,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: SETTINGS_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const settings = await getSettings(`${settingsCategory}Settings`);

		return onSuccess({ settingsCategory, settings });
	} catch (error) {
		console.log(error);
		return onError(error, settingsCategory);
	}
};

export { setSettingsRedux, getSettingsRedux };
